
/**
 * Import node modules.
 */
// npm install smoothscroll-polyfill --save
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();


/**
 * Require other JS libraries.
 */
const WebFont = require('webfontloader');
const lazysizes = require('./libs/lazysizes-5.3.1.js');
const jpInView = require('./libs/jpInView.js');
const slick = require('./libs/slick.js');


/**
 * Components
 */
const facetwp = require('./components/facetwp.js');
const navigation = require('./components/navigation.js');
const modal = require('./components/modal.js');
const group = require('./components/group.js');
const cover = require('./components/cover.js');
const gallery = require('./components/gallery.js');
const table = require('./components/table.js');
const column = require('./components/column.js');
const scroll = require('./components/scroll-to-top.js');
const paragraph = require('./components/paragraph.js');


/**
 * Blocks
 */
const accordion = require('./blocks/accordion.js');
const alert = require('./blocks/alert.js');
const boxes = require('./blocks/boxes.js');
const postList = require('./blocks/post-list.js');
const slider = require('./blocks/slider.js');


/**
 * Templates
 */

const single = require('./templates/single.js');


/*
// https://github.com/typekit/webfontloader

WebFont.load({
	// GOOGLE FONTS
	// google: {
	// 	families: [
	// 		'Barlow Condensed:300,400,500,600,700'
	// 	]
	// },
	// TYPEKIT
	// typekit: { id: 'abc123' },
	// CALLBACK FOR WHEN FONTS LOAD (OPTIONAL)
	// active: dje_fonts_active_cb
});

// Callback function for when the fonts are loaded.
function dje_fonts_active_cb() {

}
*/


// Use lazysizes to get lazy loading on css background images.
document.addEventListener('lazybeforeunveil', function (e) {
	try {
		var bg = e.target.getAttribute('data-bg');
    if (bg) {
			e.target.style.backgroundImage = 'url(' + bg + ')';
    }

	} catch (error) {
		console.log('Error with lazyload background:');
		console.log(error);
	}
});
